/**
 * Shared display helpers for the identity-merge audit UI
 * (`MergeEffectSummary.jsx` / `MergeResultSummary.jsx` and
 * `MergeHistoryCard.jsx`), pulled out so they don't drift when one is
 * updated and the others aren't.
 */
import { PATH_DASHBOARD } from '../routes/paths';

// Union of the keys each component previously tracked separately — the
// merge-result set was already a superset of MergeHistoryCard's.
export const TRANSFERRED_COUNT_LABELS = {
    treatments: 'Treatments',
    notes: 'Notes',
    media: 'Media',
    metadata: 'Metadata',
    journey_events: 'Journey events',
    attribution_snapshot: 'Attribution snapshot',
    duplicate_map_rows: 'Duplicate map rows',
};

/**
 * Turns a snake_case key (match reason, transferred-count key, etc.) into a
 * human-readable label, e.g. `manual_duplicate_merge` -> `Manual duplicate
 * merge`. Null-safe so a missing match reason never throws.
 */
export const humaniseMatchReason = (value) =>
    String(value || '')
        .replace(/_/g, ' ')
        .replace(/^./, (c) => c.toUpperCase());

export const leadDetailPath = (practiceId, leadId) =>
    PATH_DASHBOARD.general.leadDetail
        .replace(':practiceId', practiceId)
        .replace(':id', leadId)
        .replace('/:tab?', '');
